export default "__VITE_ASSET__7950afd2__"